export default [
	{
		path: '/ProcessauditProductaudit',
		component: () => import('./Productaudit.vue'),
		name:'Productaudit',
		meta: {
			title:'Sidebar.processaudit[0]'
		}
	},
	{
		path: '/Processauditsupplieraudit',
		component: () => import('./supplieraudit.vue'),
		name:'supplieraudit',
		meta: {
			title:'Sidebar.processaudit[1]'
		}
	},
	{
		path: '/Processauditdocumentsaudit',
		component: () => import('./documentsaudit.vue'),
		name:'documentsaudit',
		meta: {
			title:'Sidebar.processaudit[2]'
		}
	},
	{
		path: '/Processauditdocumentsaudit/:orderType/:id',
		component: () => import('./documentsaudit.vue'),
		name:'documentsaudit',
		meta: {
			title:'Sidebar.processaudit[2]'
		}
	},
];


// WEBPACK FOOTER //
// ./src/components/page/Processaudit/router.js